"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SavedIdView_1 = require("./SavedIdView");
exports.default = SavedIdView_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/index.js
// module id = 1721
// module chunks = 8